import { render } from "./IconNJK.vue?vue&type=template&id=3491e1f3"
import script from "./IconNJK.vue?vue&type=script&lang=js"
export * from "./IconNJK.vue?vue&type=script&lang=js"
script.render = render

export default script